import { createContext } from 'react';

const TranslationContextValue = /*#__PURE__*/createContext({
  getAvailableLanguages: () => [],
  loading: true,
  error: null
});

export { TranslationContextValue };
//# sourceMappingURL=translationContext.js.map
